import { TracThemeType } from '@services/tracpage/types/trac-theme-type';
import { TracPageState } from './state';
import _ from 'lodash';

const initialArtistPage = {
  id: '',
  ownerId: '',
  subdomain: '',
  type: 'tracpage' as 'tracpage',
  title: '',
  avatar: '',
  theme: 'dark' as TracThemeType,
  data: {
    bio: '',
    social: [],
  },
  links: [],
  removeBranding: false,
  created_at: new Date(),
  updated_at: new Date(),
};

export const tracPageInitialState: TracPageState = {
  artistPage: initialArtistPage,
  artistPageDraft: _.cloneDeep(initialArtistPage),
  isArtistPageChanged: false,
  artistPageChanges: 0,
  artistPageChangesMap: {},
  artistPreview: false,
  trackLinks: {
    editor: {
      id: '',
      ownerId: '',
      path: '',
      type: 'traclink' as 'traclink',
      title: '',
      avatar: '',
      theme: 'dark' as TracThemeType,
      data: {
        title: '',
        artistName: '',
        releaseDate: 0,
        coverUrl: '',
        videoUrl: '',
        tracks: [],
      },
      removeBranding: false,
      links: [],
      created_at: new Date(),
      updated_at: new Date(),
    },
    list: [],
  },
};
